import { useEffect, useState } from "react"
import { Info, CheckCircle2, X } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useRouter, useSearchParamsCompat } from "@/lib/router-helpers"
import { toast } from "sonner"
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp"
import { useSendOTP, useVerifyOtherOTP } from "@/hooks/use-auth"
import { useAuth } from "@/components/auth-provider"
import { useBookingStore } from "@/store/booking-store"

export default function BookingSection() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParamsCompat()
  const mode = searchParams.get("mode")

  // bookingType is now selected after scheduling, so we remove the toggle here.
  // This component might just show a header or be removed entirely if it serves no other purpose on the dashboard.
  // For now, removing the toggle functionality but keeping the container if needed for layout stability.

  if (mode === "reschedule") return null;

  // Returning null as the booking mode selection is moved to later step
  return null;
}